// Clients logos & Clients info
import kdsLogo from "../images/clients-logos/kds_positivo.webp";
import istLogo from "../images/clients-logos/IST_Logo.webp";
import lxPyroLogo from "../images/clients-logos/logoInsta.webp";
import setLogo from "../images/clients-logos/setLogo.webp";
import novaSuLogo from "../images/clients-logos/nova-su.webp";

const clients = [
  {
    id: 0,
    name: "KDS Offshore, Lda",
    link: "https://kdsoffshore.pt/",
    img: kdsLogo,
  },
  {
    id: 1,
    name: "Lx Pyro",
    link: "http://lxpyro.herokuapp.com/",
    img: lxPyroLogo,
  },
  {
    id: 2,
    name: "IST - U. Lisboa",
    link: "https://tecnico.ulisboa.pt/",
    img: istLogo,
  },
  {
    id: 3,
    name: "SET - Semana Empresarial e Tecnológica",
    link: "https://set.tecnico.ulisboa.pt",
    img: setLogo,
  },
  {
    id: 4,
    name: "NOVA SU",
    link: "https://novasu.pt",
    img: novaSuLogo,
  },
];

export default clients;
